// extracted by mini-css-extract-plugin
export default {"remove":"Item_remove__oHbxW","trash":"Item_trash__gnzbD"};